module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-for-fun"
  }, [(_vm.loading) ? _c('Loader') : _vm._e(), (!_vm.loading && _vm.props) ? _c('div', [_c('Hero', {
    attrs: {
      "props": _vm.props.acf.hero
    }
  }), _vm._m(0), _c('Testimonial')], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact_title thankyou_wrap"
  }, [_c('div', {
    staticClass: "custom-get-start-first-visit__container"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://seattle-orthodontics.com/"
    }
  }, [_vm._v("Home")])]), _c('li', [_c('a', {
    attrs: {
      "href": "https://seattle-orthodontics.com/about-us/"
    }
  }, [_vm._v("ABOUT-US")])]), _c('li', [_c('a', {
    attrs: {
      "href": "https://seattle-orthodontics.com/get-started/"
    }
  }, [_vm._v("GET-STARTED")])]), _c('li', [_c('a', {
    attrs: {
      "href": "https://seattle-orthodontics.com/online-consultation"
    }
  }, [_vm._v("ONLINE-CONSULTATION")])]), _c('li', [_c('a', {
    attrs: {
      "href": "https://seattle-orthodontics.com/technology/"
    }
  }, [_vm._v("TECHNOLOGY")])]), _c('li', [_c('a', {
    attrs: {
      "href": "https://seattle-orthodontics.com/resources/"
    }
  }, [_vm._v("Get Started")])]), _c('li', [_c('a', {
    attrs: {
      "href": "https://seattle-orthodontics.com/contact/"
    }
  }, [_vm._v("CONTACT")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73f60ad2","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/sitemap/sitemap.pug
// module id = 1129
// module chunks = 1